import { localizedLegalPage } from "./localized";
import { CookiesPage as Fr } from "./fr/CookiesPage";
import { CookiesPage as En } from "./en/CookiesPage";

export const CookiesPage = localizedLegalPage({ fr: Fr, en: En });

export default CookiesPage;
